import { Platform, platforms } from "./platform-provider";
import { ShowcaseProject } from "@/views/showcase/showcase-types";

export function getShowcaseProjectPlatform(project: ShowcaseProject): Platform {
	return platforms.filter((platform: Platform) => {
		return platform.name === project.platform;
	})[0];
}